import { render, staticRenderFns } from "./WeekWithDays.vue?vue&type=template&id=3ab7365d&scoped=true&"
import script from "./WeekWithDays.vue?vue&type=script&lang=js&"
export * from "./WeekWithDays.vue?vue&type=script&lang=js&"
import style0 from "./WeekWithDays.vue?vue&type=style&index=0&id=3ab7365d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab7365d",
  null
  
)

export default component.exports